<template>
    <div>
        <b-container class="mt-5">
            <b-row class="mt-3 mb-5">
                <b-col>
                    <b-link class="link" :to="{name: 'admin-dashboard'}"><i class="far fa-long-arrow-left mr-2"></i>Back to Organizations</b-link>
                </b-col>
            </b-row>

            <b-row class="mb-5">
                <b-col>
                    <h3 class="text-success">{{organization.title}}</h3>
                </b-col>
            </b-row>

            <b-nav class="org-nav mb-5">
                <b-nav-item exact-active-class="active" :to="{name: 'admin-org-confs'}"><i class="far fa-user-chart mr-2"></i>Conferences</b-nav-item>
                <b-nav-item exact-active-class="active" :to="{name: 'admin-org-users'}"><i class="far fa-users mr-2"></i>Users</b-nav-item>
                <b-nav-item exact-active-class="active" :to="{name: 'admin-org-edit'}"><i class="far fa-pencil mr-2"></i>Edit</b-nav-item>
            </b-nav>
        </b-container>

        <router-view/>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "conference-details",
        data() {
            return {
                organization: {}
            }
        },
        methods: {
            ...mapActions(['getOrgById'])
        },
        mounted: function () {
            this.getOrgById(this.$route.params.id).then(org => {
                this.organization = org;
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    a.link {
        color: $success;
    }
</style>

<style lang="scss">
    @import '~@/assets/scss/_variables.scss';

    .org-nav {
        .nav-item {
            margin-right: 1.5rem;

            a {
                padding: 0.2rem;

                color: $success;
                font-size: 1.1rem;

                &.active {
                    border-bottom: 3px solid $success;
                }
            }
        }
    }
</style>